module.exports = __webpack_public_path__ + "img/harmony_04.6f10bffb.jpg";